var _style, _g, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.8 280.1",
    style: {
      enableBackground: "new 0 0 212.8 280.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0094B1;}\r\n\t.st1{fill:none;}\r\n\t.st2{enable-background:new    ;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,140.3c0-35.7,0-71.3,0-107C0,12.3,12.3,0,33.2,0c31.5,0,63,0.1,94.4-0.1c9.7-0.1,17.8,3.1,24.8,9.8 c16.3,15.7,32.7,31.3,49.3,46.8c7.5,7.1,11.1,15.5,11,25.8c-0.1,55.1,0,110.3,0,165.4c0,19.6-12.6,32.3-32.2,32.3 c-49.5,0-98.9,0-148.4,0c-19.2,0-32-12.7-32.1-31.9C0,212.2,0,176.2,0,140.3z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.4,
    y: 167.6,
    className: "st1",
    width: 157.9,
    height: 81.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.5,167.6c12.7,0,21.2,8.1,21.2,20.8c0,12.6-9.1,20.7-22.4,20.7h-8.1v15.6H31.4v-57.1H57.5z M48.2,196.7h4.7 c5.6,0,8.9-2.8,8.9-8.3c0-5.4-3.3-8.2-8.8-8.2h-4.8V196.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109,167.6c17.3,0,27.5,9.8,27.5,28.1s-10.2,29-27.5,29H84.6v-57.1H109z M101.4,211.3h5.3 c8.4,0,12.8-5.1,12.8-15.6c0-9.6-4.7-14.8-12.8-14.8h-5.3V211.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143,224.6v-57.1h40.1v13.3h-23.3v11h21.1v12.6h-21.1v20.2H143z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.d49ef77da2f4263c470a69fbe056d0a2.svg";
export { ForwardRef as ReactComponent };